// ProductGroupDetailWrapper.js (hoặc file router của bạn)
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { productGroupsAPI } from '../../utils/api';
import ProductDetail from './ProductDetail';
import ProductKitDetail from './ProductKitDetail'; // Giả sử cùng cấp hoặc đường dẫn tương ứng
import './ProductGroupDetail.css'; // Giữ nguyên CSS

const ProductGroupDetailWrapper = () => {
  const { groupId } = useParams();
  const [productGroupType, setProductGroupType] = useState(null);
  const [isLoadingType, setIsLoadingType] = useState(true);

  useEffect(() => {
    const fetchProductGroupType = async () => {
      setIsLoadingType(true);
      try {
        const response = await productGroupsAPI.getProductGroupById(groupId);
        setProductGroupType(response.data.data.group_type);
      } catch (error) {
        console.error('Error fetching product group type:', error);
        // Handle error, maybe navigate to a 404 page or show a generic error
        setProductGroupType('error'); // Indicate an error state
      } finally {
        setIsLoadingType(false);
      }
    };
    fetchProductGroupType();
  }, [groupId]);

  if (isLoadingType) {
    return (
      <div className="product-group-detail loading">
        <div className="spinner"></div>
        <p>Determining product type...</p>
      </div>
    );
  }

  if (productGroupType === 'error') {
    return (
      <div className="product-group-detail error">
        <h2>Could not load product information.</h2>
        <p>Please try again or contact support.</p>
      </div>
    );
  }

  if (productGroupType === 'combo') {
    return <ProductKitDetail />;
  } else {
    // Default to ProductDetail for 'product' or any other types
    return <ProductDetail />;
  }
};

export default ProductGroupDetailWrapper;